import { useEffect, useState } from "react";
import { toast } from "sonner";
import { DatabaseBackup, Download, Lock } from "lucide-react";
import { api, API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { dt, size, STATUS, showError } from "@/components/backup/util";

export default function OfficeBackupsPage() {
  const [items, setItems] = useState([]);
  const [fresh, setFresh] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/office/backups").then((r) => setItems(r.data)).catch(showError);
  useEffect(() => { load(); }, []);
  const create = async () => {
    setBusy(true);
    try { const r = await api.post("/office/backups"); setFresh(r.data); toast.success("Yedeğiniz hazır. Bugün içinde indirin."); load(); }
    catch (e) { await showError(e); }
    setBusy(false);
  };
  const link = fresh && `${API.replace(/\/api$/, "")}${fresh.download_path}`;
  return (
    <div className="space-y-6" data-testid="office-backups-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1">Ofis</div>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Yedeklerim</h1>
        <p className="text-slate-500 mt-1">Ofisinizin tüm kayıtları ve belgeleri (görsel ve videolar hariç) şifreli .emlakplus dosyası olarak yedeklenir.</p>
      </div>
      <Card className="p-5 space-y-4">
        <div className="flex flex-wrap items-center gap-3">
          <DatabaseBackup className="w-5 h-5 text-emerald-700" />
          <div className="mr-auto text-sm text-slate-600 max-w-2xl">
            İndirme bağlantısı <b>yalnızca bugün</b> geçerlidir ve <b>tek kullanımlıktır</b>. Dosya indirildiğinde ya da gün bittiğinde sunucudan kalıcı olarak silinir.
          </div>
          <Button data-testid="office-backup-create-btn" disabled={busy} onClick={create}>{busy ? "Hazırlanıyor..." : "Yedek al"}</Button>
        </div>
        {fresh && (
          <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 flex flex-wrap items-center gap-3" data-testid="office-backup-link-box">
            <div className="flex-1 min-w-[220px] text-sm">
              <div className="font-semibold text-emerald-900 font-mono">{fresh.filename}</div>
              <div className="text-xs text-emerald-800">{size(fresh.size)} · Son indirme: {dt(fresh.expires_at)}</div>
            </div>
            <a href={link} data-testid="office-backup-download-link" onClick={() => setTimeout(() => { setFresh(null); load(); }, 1500)}
              className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-semibold px-4 py-2 transition-colors">
              <Download className="w-4 h-4" />İndir
            </a>
          </div>
        )}
        <div className="flex items-start gap-2 text-xs text-slate-500"><Lock className="w-3.5 h-3.5 mt-0.5" />Dosya başka programlarla açılamaz; yalnızca EmlakPlus geri yükleme sistemi tarafından çözülebilir. Geri yükleme için EmlakPlus destek ekibine iletebilirsiniz.</div>
      </Card>
      <Card className="overflow-hidden">
        {items.length === 0 ? <div className="p-8 text-center text-sm text-slate-400">Henüz yedek alınmadı</div> : items.map((b) => (
          <div key={b.id} className="flex flex-wrap items-center gap-3 p-4 border-b last:border-0" data-testid={`office-backup-${b.id}`}>
            <div className="flex-1 text-sm"><div className="font-mono font-semibold">{b.filename}</div><div className="text-xs text-slate-500">{dt(b.created_at)} · {b.created_by} · {size(b.size)}</div></div>
            <Badge variant="outline">{STATUS[b.status] || b.status}</Badge>
          </div>
        ))}
      </Card>
    </div>
  );
}
